import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import "react-datetime/css/react-datetime.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import Datetime from "react-datetime";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Exportcsv from "../loginpages/Managementpages/Exportcsv";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
// import { DecryptData, EncryptData } from '../../../actions/common';

function FinanceVendorsView() {
  const [opacity, setOpacity] = useState("false");
  const [selectedOption, setSelectedOption] = useState(null);
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const columns = [
    { dataField: "sno", text: "S.No", sort: true },
    { dataField: "name", text: "Name" },
    { dataField: "gender", text: "Gender" },
    { dataField: "bagid", text: "BagID" },
    { dataField: "dob", text: "Date Of Birth" },
  ];

  const data = [
    {
      sno: <p className="table_secondarytxt">1968</p>,
      name: <p className="">David</p>,
      gender: "$10,000",
      taxes: <p className="table_secondarytxt">Male</p>,
      bagid: <p className="">JA2323jd34</p>,
      dob: <p className="table_secondarytxt">2.5.1989</p>,
    },
    {
      sno: <p className="table_secondarytxt">1968</p>,
      name: <p className="">David</p>,
      gender: "$10,000",
      taxes: <p className="table_secondarytxt">Male</p>,
      bagid: <p className="">JA2323jd34</p>,
      dob: <p className="table_secondarytxt">2.5.1989</p>,
    },
    {
      sno: <p className="table_secondarytxt">1968</p>,
      name: <p className="">David</p>,
      gender: "$10,000",
      taxes: <p className="table_secondarytxt">Male</p>,
      bagid: <p className="">JA2323jd34</p>,
      dob: <p className="table_secondarytxt">2.5.1989</p>,
    },
    {
      sno: <p className="table_secondarytxt">1968</p>,
      name: <p className="">David</p>,
      gender: "$10,000",
      taxes: <p className="table_secondarytxt">Male</p>,
      bagid: <p className="">JA2323jd34</p>,
      dob: <p className="table_secondarytxt">2.5.1989</p>,
    },
  ];

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered

          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"

              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "35px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "35px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "35px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  return (
    <>

      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec mt-4">
            <div>
              <p className="page_title">Monthly Report</p>
            </div>
            <div className="rightside">
              <div className="rightside_select">
                <Select
                  options={options}
                  defaultValue={selectedOption}
                  styles={stylesgraybg}
                  onChange={setSelectedOption}
                  className="border_blue_select"
                  classNamePrefix="react-select"
                  placeholder="Type"
                />
              </div>

              <div className="order_calendar_div finance_order_calendar_div">
                <p
                  className={
                    opacity == "true" ? "hiding_caltxt" : ""
                  }
                >
                  2022
                </p>
                <img
                  className="order_calendar_ic"
                  src={require("../../assests/images/calendar.png")}
                  alt="calender"

                />
                <Datetime
                  onChange={() => {
                    setOpacity("true");
                  }}
                  className="order_datepick"
                />
              </div>

              <button
                type="button"
                className="btn primary-style padding_lessbtn"
              >
                <Exportcsv
                  className="cmn_exportcsvs"
                  //  csvData={exportdata}
                  fileName={"SubCategory"}
                />
              </button>
            </div>
          </div>
        </div>
        <div className=" mt-4">
          <div className="ffd_table finance_ffdtable">
            <BootstrapTable
              bootstrap4
              keyField="id"
              columns={columns}
              data={data}
              pagination={pagination}
              noDataIndication="No Monthly Report found"
            />
          </div>

          {/* <div className='sec_border'>

      <div className='row'>
        <div className='col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12'>
        <div className='whole_searchbar white_bg'>
   <img className='search_glass' src={require('../../assests/images/Search.png')}/>
  <input placeholder="Search term"/>
   </div>
        </div>

        <div className='col-xxl-8 col-xl-8 col-lg-9 col-md-9 col-sm-12 col-12'>
        <div className='rightside'>

<div className='rightside_select'>
        <Select
                            // options={options}
                            // defaultValue={selectedOption}
                            // styles={stylesgraybg}
                            // onChange={setSelectedOption}
                            className="border_blue_select"
                            classNamePrefix="react-select"
                            placeholder='Type'
                       
                          />
                          </div>

                          <div className='rightside_select'>
        <Select
                            // options={driveroptions}
                            // defaultValue={selectedOption}
                            // styles={stylesgraybg}
                            // onChange={setSelectedOption}
                            className="border_blue_select"
                            classNamePrefix="react-select"
                            placeholder='Status'
                       
                          />
                          </div>

                        
  
        </div>

       
        </div>

       
      </div>
      
    </div> */}
        </div>
      </section>

    </>
  );
}

export default FinanceVendorsView;
